import React from "react";
import PropTypes from "prop-types";
import { FormRow } from "./FormRow";
import { FormInputField } from "@arcteryx/components-form";

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const TextInput = ({
  id,
  label,
  required,
  register,
  errors,
  requiredMsg,
  validInputs,
  setValidInputs
}) => {
  let formValidation = { ...register(id) };

  if (requiredMsg) {
    formValidation = {
      ...register(id, {
        required: requiredMsg[language],
        validate: {
          validInput: value =>
            value.length > 0
              ? setValidInputs(prev => ({
                  ...prev,
                  [id]: true
                }))
              : setValidInputs(prev => ({
                  ...prev,
                  [id]: false
                }))
        }
      })
    };
  }

  if (requiredMsg && id === "email") {
    formValidation = {
      ...register(id, {
        required: requiredMsg[language],
        pattern: {
          value: emailRegex,
          message: requiredMsg[language]
        },
        validate: {
          validEmail: value =>
            emailRegex.test(value)
              ? setValidInputs(prev => ({
                  ...prev,
                  [id]: true
                }))
              : setValidInputs(prev => ({
                  ...prev,
                  [id]: false
                }))
        }
      })
    };
  }

  return (
    <FormRow>
      <FormInputField
        name={id}
        data-testid={id}
        type="text"
        id={id}
        label={label}
        required={required}
        valid={validInputs[id]}
        {...formValidation}
        error={errors[id]}
      />
    </FormRow>
  );
};

TextInput.defaultProps = {
  requiredMsg: null
};

TextInput.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  required: PropTypes.bool.isRequired,
  register: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  validInputs: PropTypes.object.isRequired,
  setValidInputs: PropTypes.func.isRequired,
  requiredMsg: PropTypes.object
};

export default TextInput;
